<div class="about-area-two pb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-5 col-md-12">
                <div class="about-content-box">
                    <h2>Build Your Future in Paramedical Science</h2>
                    <p>We aim at inspiring our students to dream more, learn more, do more, and become more in their
                        respective journeys of life..</p>
                    <p><strong>Grow your knowledge and your opportunities with thought leadership, training and
                            tools.</strong></p>
                    <a href="contact" class="link-btn">Explore Learning</a>
                </div>
            </div>
            <div class="col-lg-7 col-md-12">
                <div class="about-video-box">
                    <div class="image">
                        <img src="images/videoframe.png" alt="image">
                    </div>
                    <div class="video-btn" (click)="openPopup()">
                        <i class="fa-solid fa-play"></i>
                    </div>
                    <div class="shape10"><img src="images/shape9.png" alt="image"></div>
                </div>
            </div>
        </div>
    </div>
    <div class="shape3"><img src="images/shape3.png" alt="image"></div>
    <div class="shape4"><img src="images/shape4.png" alt="image"></div>
    <div class="shape2"><img src="images/shape2.png" alt="image"></div>
</div>

<!-- Video Popup -->
<div class="video-popup position-fixed d-flex align-items-center justify-content-center text-center top-0 start-0 end-0 bottom-0"
    *ngIf="isOpen" (click)="closePopup()">
    <div class="popup-inner position-relative mx-auto">
        <!-- <video controls autoplay>
            <source src="images/about-video.mp4" type="video/mp4">
        </video> -->
        <iframe [src]="safeYoutubeUrl" title="Web Design Trends 2025" frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <button (click)="closePopup()" type="button"
            class="close-btn p-0 border-0 d-flex align-items-center justify-content-center rounded-circle">
            <i class="fa-solid fa-xmark"></i>
        </button>
    </div>
</div>